import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useSelector } from "react-redux";
import NavMenu from './NavMenu.js';
import CartBadge from '../CartBadge/CartBadge.js';
import { useCart } from "../../context/CartContext";
import SearchBox from './SearchBox.js';
import "./header.css";

// import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
// import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
// import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import Logo from '../../assets/images/logos/logo.png'

export default function Header() {
  const { menu = [], category = [], loading = true, error } = useSelector(state => state.menuState);
  const navigate = useNavigate();
  const [shrunken, setShrunken] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [cartOpen, setCartOpen] = useState(false);
  const { cartItems } = useCart(); // get cart items from context

  useEffect(() => {
    const onScroll = () => setShrunken(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (!e.target.closest(".header-root")) {
        setOpenDropdown(null);
        setCartOpen(false);
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  const toggle = (name) => {
    if (openDropdown === name) setOpenDropdown(null);
    else setOpenDropdown(name);
  };

  const headerVariants = {
    normal: { background: "rgba(255,255,255,0.96)" },
    shrunken: {
      background: "rgba(248,249,250,0.95)",
      boxShadow: "0 6px 18px rgba(21,21,21,0.06)",
      backdropFilter: "blur(8px)",
    },
  };

  const dropVariants = {
    hidden: { opacity: 0, y: -8 },
    enter: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -8 },
  };

  const cartHandlerClick = () => {
    navigate("/cart");
  }

  return (
    <header className="sticky-top bg-white shadow-sm">
      <div className="container-fluid px-3 px-lg-5 py-2">
        <motion.div
        // className={`site-header px-3 ${shrunken ? "is-shrunk" : ""}`}
        // initial="normal"
        // animate={shrunken ? "shrunken" : "normal"}
        // variants={headerVariants}
        // transition={{ duration: 0.25, ease: "easeOut" }}
        >

          {/* === MOBILE HEADER ROW 1 === */}
          <div className="d-flex w-100 align-items-center d-md-none justify-content-between mobile-header-row1">
            {/* Hamburger */}
            <NavMenu menu={menu} categories={category} />

            {/* Logo */}
            <div
              className="brand-logo"
              onClick={() => (window.location.href = "/")}
              style={{ cursor: "pointer" }}
            >
              <img
                src={Logo}
                alt="Logo"
                className="logo-img"
                style={{
                  height: "60px",
                  width: "auto",
                  objectFit: "contain",
                }}
              />
            </div>

            {/* Icons */}
            <div className="d-flex align-items-center">
              <CartBadge count={cartItems?.length} onClick={cartHandlerClick} />
            </div>
          </div>

          {/* === MOBILE HEADER ROW 2: SEARCH BAR === */}
          <div className="d-md-none mobile-header-row2 mt-2">
            <div className="search-wrapper">
              <div
                className="search-box d-flex align-items-center px-2 py-1 shadow-sm bg-light"
                style={{
                  border: "1px solid #e5e5e5",
                  transition: "all 0.2s ease",
                  background: "#ffffff",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  className="form-control border-0 bg-transparent flex-grow-1 px-3 search-input"
                  placeholder="Search products, ingredients, rituals..."
                  onFocus={() => setOpenDropdown("search")}
                  style={{
                    fontSize: "15px",
                    color: "#151515",
                  }}
                />

                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => alert("Search clicked!")}
                  className="btn search-btn d-flex align-items-center justify-content-center"
                  style={{
                    background: "#ffb100",
                    color: "#ffffff",
                    width: "42px",
                    height: "42px",
                    border: "none",
                  }}
                >
                  <SearchOutlinedIcon sx={{ fontSize: 22 }} />
                </motion.button>
              </div>
            </div>
          </div>

          {/* === DESKTOP HEADER === */}
          <motion.div
            className="d-none d-md-flex flex-column custom-container"
          // initial="normal"
          // animate={shrunken ? "shrunken" : "normal"}
          // variants={headerVariants}
          // transition={{ duration: 0.25, ease: "easeOut" }}
          >
            {/* LEFT */}
            <div className="d-flex align-items-center justify-content-between py-2">
              <div
                className="brand-logo me-3"
                onClick={() => (window.location.href = "/")}
                style={{ cursor: "pointer" }}
              >
                <motion.img
                  whileHover={{ scale: 1.05 }}
                  src={Logo}
                  alt="WellnessCo Logo"
                  className="logo-img"
                  style={{
                    height: "60px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                />
              </div>

              {/* Brands */}
              <div className="me-2 nav-item position-relative">
                <NavMenu menu={menu} categories={category} />
              </div>

              <SearchBox />
              <CartBadge count={cartItems?.length} onClick={cartHandlerClick} />
            </div>
            {/* <div className="d-flex justify-content-start mt-2">
              <NavMenu menu={menu} categories={category} />
            </div> */}
            {/* CENTER */}
            {/* <div className="header-center flex-grow-1 d-flex justify-content-center">
              <SearchBox />
            </div> */}

            {/* RIGHT */}

          </motion.div>
        </motion.div>

        {/* Mobile Menu Panel */}
        <AnimatePresence>
          {openDropdown === "mobileMenu" && (
            <motion.div
              className="mobile-menu shadow-sm bg-white position-absolute top-100 start-0 w-100"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
            >
              <NavMenu menu={menu} categories={category} mobile />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>

  );
}
